import React, { Component } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';

class Gallery extends Component {
  constructor() {
    super();
    this.state = {
      showNav: false,
      showVideo: {},
      images: [],
    };
  }

  renderVideo(item) {
    const video_id = this.getYouTubeID(item.embedUrl);
    const embed_url = `https://www.youtube.com/embed/${video_id}`;
    const original = `https://img.youtube.com/vi/${video_id}/hqdefault.jpg`;
    return (
      <div className="image-gallery-image">
        {this.state.showVideo[embed_url] ? (
          <div className="video-wrapper">
            <span className="close-video" onClick={this.toggleShowVideo.bind(this, embed_url)} />
            <iframe src={embed_url} frameBorder="0" allowFullScreen />
          </div>
        ) : (
          <span onClick={this.toggleShowVideo.bind(this, embed_url)}>
            <div className="play-button" />
            <img src={original} alt="youtube" />
            <span
              style={{ position: 'absolute', top: '45%', left: '45%' }}
              className="fab fa-youtube fa-5x txt-white justify-content-center"
            />
            {item.description && (
              <span className="image-gallery-description" style={{ right: '0', left: 'initial' }}>
                <span className="txt-bold">Video:</span> {item.description}
              </span>
            )}
          </span>
        )}
      </div>
    );
  }

  toggleShowVideo(url) {
    this.state.showVideo[url] = !Boolean(this.state.showVideo[url]);
    this.setState({
      showVideo: this.state.showVideo,
    });
  }

  playPrevious = () => {
    this.galleryRef.slideToIndex(this.galleryRef.getCurrentIndex() - 1);
  };

  playNext = () => {
    this.galleryRef.slideToIndex(this.galleryRef.getCurrentIndex() + 1);
  };

  getYouTubeID(url) {
    if (!url) return '';
    let ID = '';
    url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_\-]/i);
      ID = ID[0];
    } else {
      ID = url;
    }
    return ID;
  }

  handleMedias(medias) {
    if (medias && medias.length)
      this.setState({
        images: medias.map((item, index) => {
          if (item.type === 'video') {
            let video_id = this.getYouTubeID(item.url);
            return {
              index,
              original: `https://img.youtube.com/vi/${video_id}/hqdefault.jpg`,
              thumbnail: `https://img.youtube.com/vi/${video_id}/default.jpg`,
              embedUrl: item.url,
              description: item.description,
              renderItem: this.renderVideo(item),
            };
          } else {
            return {
              index,
              original: item.url,
              thumbnail: item.url.replace('/storage', '/storage/thumbnails'),
              description: item.description,
              local: item.groupe.name,
            };
          }
        }),
      });
    else this.setState({ images: [] });
  }

  componentDidMount() {
    this.handleMedias(this.props.medias);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.medias !== this.props.medias) {
      this.handleMedias(this.props.medias);
    }
  }

  render() {
    return (
      <section className={`d-none d-sm-block pt-4 ${this.props.background}`} id="gallery">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <span className="txt-bold txt-25px txt-white txt-uppercase">Gallerie photos - videos</span>
            </div>
            <div className="col-12">
              {this.props.medias.length > 0 ? (
                <div className="row flex-row justify-content-center m-0 p-0">
                  <div className="row flex-column offset-md-1 col-md-8 m-2 w-100">
                    <ImageGallery
                      ref={ref => (this.galleryRef = ref)}
                      showThumbnails={false}
                      showIndex={false}
                      items={this.state.images}
                      showNav={this.state.showNav}
                      autoPlay={true}
                      showPlayButton={false}
                    />
                    <div className="row flex-row justify-content-center align-items-center">
                      <span
                        onClick={this.playPrevious}
                        className="fas fa-angle-left m-5"
                        style={{ color: 'white', fontSize: 50 }}
                      />
                      <span
                        onClick={this.playNext}
                        className="fas fa-angle-right m-5"
                        style={{ color: 'white', fontSize: 50 }}
                      />
                    </div>
                  </div>
                  <div className="row flex-row col-md-2 align-items-center justify-content-center max-height-gallery mb-4">
                    {this.state.images.map((e, key) => {
                      return (
                        <img
                          key={key}
                          className="row m-2 flex-wrap"
                          src={e.thumbnail}
                          width={120}
                          alt="thumbnail"
                          onClick={() => this.galleryRef.slideToIndex(e.index)}
                        />
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="pt-5 pb-5">
                  <span className="fas fa-circle-o-notch fa-5x fa-spin" />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.jsx